import { createContext, useContext, type ReactNode } from 'react'

const ProjectIdContext = createContext<string | undefined>(undefined)

export function ProjectIdProvider({ value, children }: { value: string | undefined; children: ReactNode }) {
  return <ProjectIdContext.Provider value={value}>{children}</ProjectIdContext.Provider>
}

export function useProjectId(): string {
  const id = useContext(ProjectIdContext)
  if (!id) throw new Error('useProjectId() must be used within a <ProjectIdProvider>')
  return id
}
